import { render, staticRenderFns } from "./AvailabilityInfo.vue?vue&type=template&id=0f5b8696"
import script from "./AvailabilityInfo.vue?vue&type=script&lang=js"
export * from "./AvailabilityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports